module.exports = __webpack_public_path__ + "img/Henan-power.7e8cba93.png";